module.exports = __webpack_public_path__ + "img/card-brand-mastercard.865906c0.png";